import { useEffect, useRef, useState } from "react";
import { useResourceContext } from "@/layouts/ResourceContext";
import AddonCard from "../control/AddonCard";
import { listAddons } from "@/apis/addons";
import { List } from "@refinedev/antd";
import { AddonActions } from "../control/AddonActions";
import { ViewAddon } from "@/pages/instance/addons/ViewAddon";
import { EditAddon } from "@/pages/instance/addons/EditAddon";
import { Breadcrumb, Space } from "antd";
import { useInvalidate, useList } from "@refinedev/core";

export const InstanceAddonsPanel = () => {
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedInstance] } = state;
  const id = selectedInstance?.id;
  //const [isLoading, setIsLoading] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState("");
  const [action, setAction] = useState("");
  const invalidate = useInvalidate();

  const {data: addons, isLoading} = useList({
    resource: "addons",
    meta:{id: id}
  })

  const clickAction = (action) => {
    setAction(action);
  };

  const getBreadcrumbItems = () => {
    const items = [];
    items.push({
      title: <a onClick={() => setAction("")}>Addons</a>,
    });
    items.push({
      title: addons.data.find((item) => {return item.addon.id == selectedCardId})?.addon.name,
    });
    return items;
  }

  return (
    <div>
      {action !== "" && <Breadcrumb items={getBreadcrumbItems()} />}
      {action === "view"  && <ViewAddon id={id} addonId={selectedCardId} onBack={clickAction}/> } 
      {action === "edit"  && <EditAddon id={id} addonId={selectedCardId} addonName={addons?.data.find((item) => item.addon.id == selectedCardId)?.addon.name} onBack={clickAction}/> } 
      {action === "" && <List
        title="Add-ons"
        headerButtons={<AddonActions addonId={selectedCardId} addonName={addons?.data.find((item) => item.addon.id == selectedCardId)?.addon.name} clickAction={clickAction}/>}
        isLoading={isLoading}
        breadcrumb={false}
      >
        <Space style={{width: '100%'}} direction="vertical">
          {addons? addons.data.map(item => (
            <AddonCard
              addon={item.addon}
              instanceId={item.id}
              selectedCardId={selectedCardId}
              setSelectedCardId={setSelectedCardId}
            />
          )) : []}
        </Space>
      </List>}
    </div>
  );
};